<template>
    <div class="col-lg-2 col-md-12 date-status">
        <div class="row" >
            <div class="col-lg-12 col-md-6" v-if="form.date_created!=null" style="position: relative; margin-bottom: 6px;">
                <date-doc :dateDoc="new Date(form.date_created)" :labelDoc="'Document Date:'" ref="dateDoc" @returnValue="getResponseDateDoc($event)"></date-doc>
                <!--
                <label for="form.date_created">Document Date:</label>
                <div class="input-group">
                    <button class="form-control show_date date_doc" @click="openDateCreatedPicker()">
                        <i class="far fa-calendar-alt"></i>
                        <span class="formatted-date">{{ formatDate(form.date_created) }}</span>
                    </button>
                    <input
                        type="date"
                        required
                        class="form-control date_hiden"
                        ref="date_created"
                        v-model="form.date_created"
                        @change="updateDateNewFormat"
                    />
                </div>
                -->
            </div>
            <!--
            <div class="form-group col-lg-12 col-md-6" v-if="form.date_created!=null">
                <label for="form.date_createdInput">Document Date</label>
                <div :class="['date-label', (disabledSteps.customer) ? 'disabled' : '']">
                    {{ form.date_created | moment("MMM DD, YYYY") }}
                </div>
                <input type="text" class="form-control" v-model="form.date_created" required="true" disabled style="display:none;" />
            </div>
            -->
            <div class="form-group col-lg-12 col-md-6" v-if="form.status!=null">
                <!-- <label for="statusInput">Status</label> -->
                <div class="fillStatus">
                    <span class="cdropdown" v-if="disabledSteps.customer">
                        <button type="button" class="btn-status disabled">
                            <span style="">Disabled</span>
                        </button>
                    </span>
                    <span class="cdropdown" v-else>
                        <button type="button" :class="['btn-status',
                            (form.status == 1) ? 'pending' :
                                (form.status == 2) ? 'accepted' :
                                    (form.status == 3) ? 'rejected' :
                                        (form.status == 4) ? 'void' :
                                            (form.status == 5) ? 'signed' : 'inactivo'
                        ]">
                            <span v-for="(i, idx) in statusdata" :key="idx"
                                :style="(form.status != i.value) ? 'display:none;' : ''">
                                {{ i.name }}
                            </span>
                        </button>
                        <label>
                            <input type="checkbox" id="statusInput" />
                            <ul class="actions-status">
                                <li v-for="(i, idx) in statusdata" :key="idx"
                                    :style="(form.status != i.value && i.value != 5 && i.value != 4) ? '' : 'display:none;'"
                                    @click="changeStatus(i.value)">
                                    {{ i.name }}
                                </li>
                            </ul>
                        </label>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import setDateDoc from './../setDateDoc.vue';
export default {
    components: {
        "date-doc": setDateDoc,
    },
    props: [
        "controlLoad",
        "propdisabledSteps",
        "propForm",
    ],
    data() {
        return {
            disabledSteps: this.propdisabledSteps,
            form: {
                status: null,
                date_created: null,
            },
            statusdata: [
                { value: "1", name: "Pending" },
                { value: "2", name: "Accepted" },
                { value: "3", name: "Rejected" },
                { value: "4", name: "Void" },
                { value: "5", name: "Signed" },
            ],
        }
    },
    created() {
        let t = this;
        this.form.status = this.propForm.status;
        this.form.date_created = this.propForm.date_created;
    },
    watch : {
        controlLoad: function(){
            let t = this;
            if(this.controlLoad){
                this.form.status = this.propForm.status;
                this.form.date_created = this.propForm.date_created;
            }
        },
        "form.date_created": function (newVal) {
            // console.log('watch dateDoc', newVal);
            if(newVal==null || newVal==''){
                this.validDateDoc();
            }
        },
    },
    methods: {
        validDateDoc() {
            this.form.date_created = new Date().toISOString().split("T")[0]; // Obtiene la fecha en formato YYYY-MM-DD
            // console.log('validDateDoc', this.form.date_created);
        },
        changeStatus(val){
            let t = this;
            t.form.status = val;
            t.updateDateNewFormat()
        },
        updateData(date_created){
            let t = this;
            console.log("updateData", this.exportDate(date_created))
            t.$emit('updateProps', {
                "status": t.form.status,
                "date_created": this.exportDate(date_created),
            })
        },
        getResponseDateDoc(data){
            let t = this;
            console.log("getResponseDateDoc", data.date_doc)
            t.form.date_created = data.date_doc;
            t.updateDateNewFormat();
        },
        validDateCreated() {
            this.form.date_created = new Date().toISOString().split("T")[0]; // Obtiene la fecha en formato YYYY-MM-DD
            // console.log('validDateCreated', this.form.date_created);
        },
        openDateCreatedPicker() {
            this.$refs.date_created.showPicker(); // Abre el calendario
        },
        fragmetarFecha(dateValue) {
            if (!dateValue) return;
            // console.log('fragmetarFecha', dateValue);
            let dateSinHoras = (dateValue.indexOf('T')>-1) ? dateValue.split("T")[0] : dateValue;
            // console.log('dateSinHoras', dateSinHoras);
            let parts = dateSinHoras.split("-");
            // console.log('parts', parts);
            return parts;
        },
        formatDate(dateValue) {
            if (!dateValue) return;
            // console.log('formatDate');
            let parts = this.fragmetarFecha(dateValue);
            // console.log('parts', parts);
            let date = new Date(parts[0], parseInt(parts[1] - 1), parts[2]); // Año, Mes-1, Día
            return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" }); // formato corto, Feb 1, 2021
        },
        exportDate(dateValue) {
            if (!dateValue) return;
            return dateValue + 'T23:31:04.000Z'; // Añade la hora
        },
        updateDateNewFormat() {
            if (!this.form.date_created) return;
            let parts = this.fragmetarFecha(this.form.date_created);
            let date = parts[0]+'-'+parts[1]+'-'+(parts[2] > 9 ? parts[2] : ((parts[2]).toString().length==1) ? '0'+parts[2] : parts[2]); // Año-(Mes-1)-Día
            console.log('updateDateNewFormat', date);
            this.updateData(date);
        },
    },
};
</script>
<style scoped>
.input-group > .form-control.show_date {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
}
.input-group > .form-control.show_date span.formatted-date {margin-left: 15px;}
.input-group > .form-control.date_hiden {
    position: absolute;
    width: 100%;
    height: 37px;
    z-index: -1;
    pointer-events: none;
}
</style>
